import { Box, Checkbox, Divider, Grid, Typography } from '@mui/material';
import { NoImage } from '../../../../../../assets/Icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeIsSelect,
  changeNoqrDataSelect,
  getAllSupplierScan,
} from '../../../../../../store/purchase/purchaseSupplier/purchaseSubmitSupplier';
import { getAllPurchaseRouting } from '../../../../../../store/Routing/purchaseRouting';
import { useState } from 'react';
import { getAllQrCode } from '../../../../../../api/qrcode';
import { useEffect } from 'react';
import { LoadingComponent } from '../../../../../../components/shared/shared2';

const UnscannedData = () => {
  const dispatch = useDispatch();
  const {
    isExist,
    scanned,
    idScanned,
    allData,
    noqrDataSelect,
    isSelect,
    noqr,
    noqrid,
  } = useSelector(getAllSupplierScan);

  const handleChange = (event, item, id) => {
    dispatch(changeNoqrDataSelect({ item, id }));
  };

  useEffect(() => {
    noqrDataSelect?.length > 0
      ? dispatch(changeIsSelect(true))
      : dispatch(changeIsSelect(false));
  }, [noqrDataSelect]);

  return (
    <>
      <Grid container columns={1} sx={{ pb: '54px' }}>
        {/* qr code */}
        <Grid item xs={1}>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#9E9D9D',
              background: '#FAFAFA',
              mt: 3,
              padding: '12px',
            }}
          >
            QR Code
          </Typography>
        </Grid>
        {allData?.withqr?.filter((list) => !idScanned.includes(list.encript))
          .length === 0 ? (
          <Grid item xs={1} sx={{ textAlign: 'center', padding: '12px' }}>
            <Typography sx={{ fontSize: '10px', color: '#9E9D9D' }}>
              no data found
            </Typography>
          </Grid>
        ) : (
          allData?.withqr
            ?.filter((list) => !idScanned.includes(list.encript))
            .map((list, index) => (
              <Grid item xs={1} key={index}>
                <Box
                  sx={{
                    p: '14px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {list?.gambar ? (
                      <Box
                        sx={{
                          borderRadius: '8px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          bgcolor: '#F5F5F5',
                          width: '45px',
                          height: '45px',
                        }}
                      >
                        <img
                          src={
                            process.env.REACT_APP_API_IMAGE_BASE_URL +
                            '/' +
                            list?.gambar
                          }
                          style={{
                            width: '45px',
                            height: '45px',
                            borderRadius: '8px',
                          }}
                          alt="gbr"
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          borderRadius: '8px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          bgcolor: '#F5F5F5',
                          width: '45px',
                          height: '45px',
                        }}
                      >
                        <NoImage />
                      </Box>
                    )}
                    <Box>
                      <Typography sx={{ fontSize: '12px' }}>
                        {list?.namaProduk}
                      </Typography>
                      <Typography
                        sx={{ fontSize: '12px', fontWeight: '600', mt: '4px' }}
                      >
                        1 {list?.unit}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{}}>
                    {/* <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>
                    Rp.1.000.000
                  </Typography> */}
                  </Box>
                </Box>
                <Divider />
              </Grid>
            ))
        )}

        {/* no qr */}
        <Grid item xs={1}>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#9E9D9D',
              background: '#FAFAFA',
              mt: 3,
              padding: '12px',
            }}
          >
            Non QR Code
          </Typography>
        </Grid>

        {allData?.noqr?.filter(
          (list) =>
            !noqrid.some((item) => item.id_detail.includes(list.idProduk))
        ).length === 0 ? (
          <Grid item xs={1} sx={{ textAlign: 'center', padding: '12px' }}>
            <Typography sx={{ fontSize: '10px', color: '#9E9D9D' }}>
              no data found
            </Typography>
          </Grid>
        ) : (
          allData?.noqr
            ?.filter(
              (list) =>
                !noqrid.some((item) => item.id_detail.includes(list.idProduk))
            )
            .map((list, index) => (
              <Grid item xs={1} key={index}>
                <Box
                  sx={{
                    padding: '14px 0px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      // justifyContent: 'center',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Checkbox
                      checked={
                        noqrDataSelect?.filter(
                          (val) => val.idProduk === list.idProduk
                        ).length !== 0
                      }
                      onChange={(event) => {
                        handleChange(event, list, list?.idProduk);
                      }}
                    />

                    {list?.gambar ? (
                      <Box
                        sx={{
                          borderRadius: '8px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          bgcolor: '#F5F5F5',
                          width: '45px',
                          height: '45px',
                          gap: 2,
                        }}
                      >
                        <img
                          src={
                            process.env.REACT_APP_API_IMAGE_BASE_URL +
                            '/' +
                            list?.gambar
                          }
                          style={{
                            width: '45px',
                            height: '45px',
                            borderRadius: '8px',
                          }}
                          alt="gbr"
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          borderRadius: '8px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          bgcolor: '#F5F5F5',
                          width: '45px',
                          height: '45px',
                          gap: 2,
                        }}
                      >
                        <NoImage />
                      </Box>
                    )}

                    <Box>
                      <Typography sx={{ fontSize: '12px' }}>
                        {list?.namaProduk}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{}}>
                    <Typography
                      sx={{ fontSize: '12px', fontWeight: '600', mt: '4px' }}
                    >
                      {list?.qty} {list?.unit}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
              </Grid>
            ))
        )}
      </Grid>
    </>
  );
};
export default UnscannedData;
